import React, { PureComponent } from "react";
import { Row, Wrapper, Copy, Scroll } from "app/NativeComponents/common";
import { connect } from "react-redux";
import {
  pushSidePanel,
  setLastSavedMapFilters,
  updateMapFilters
} from "app/NativeActions";
import {
  UpsellButton,
  GhostButton,
  SmallHeader,
  BottomNavBar,
  InlineButton,
  ConfirmInlineButton,
  InputBox,
  SelectItem,
  SmallLabel,
  ConfirmLabel
} from "app/NativeComponents/snippets";
import AdvancedFilters from "app/DealMachineCore/reuseable/AdvancedFilters";
class HighlightFilters extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      is_selecting: false,
      loading: false,
      deleting: false,
      saved_filter: null,
      confirm_save: false,
      filter_id: props.filter_id || null,
      filter_name: props?.filter_name || "",
      default_filter: props.default_filter || false,
      filters: props.filters || {
        data: [],
        andor_type: "or"
      }
    };

    this.checkIfNeedsToSave = this.checkIfNeedsToSave.bind(this);
    this._filter_name = React.createRef();
  }

  componentDidUpdate(prevProps) {
    // [SUP-225] observe the sync-to-applied_highlight decision (fires vs skipped-because-is_selecting)
    const propsChanged =
      JSON.stringify(this.props.filters) !== JSON.stringify(prevProps.filters);
    if (propsChanged) {
      console.log(
        "[SUP-225] HighlightFilters.componentDidUpdate propsFilters changed. is_selecting:",
        this.state.is_selecting,
        "-> will sync applied_highlight:",
        !this.state.is_selecting,
        "props.filters count:",
        this.props.filters?.data?.length ?? "n/a",
        "state.filters count:",
        this.state.filters?.data?.length ?? "n/a"
      );
    }
    if (
      JSON.stringify(this.props.filters) !==
      JSON.stringify(prevProps.filters) &&
      !this.state.is_selecting
    ) {
      this.props.setAppliedHighlight({
        applied_highlight: this.props.filters
      });
    }
  }


  checkIfNeedsToSave() {
    const { filters, default_filter } = this.state;
    const {
      filters: propsFilters,
      default_filter: propsDefault,
      map_filters,
      last_saved_map_filters
    } = this.props;

    // --- New: don't show the bar if *nothing* is selected ---
    const noHighlight =
      !(propsFilters?.data?.length > 0);

    const noMap =
      !(map_filters?.property_flags?.length > 0) &&
      !(map_filters?.property_types?.length > 0) &&
      !map_filters?.beds_min &&
      !map_filters?.baths_min &&
      !map_filters?.value_range_min &&
      !map_filters?.value_range_max &&
      !map_filters?.use_beds_exact;

    if (noHighlight && noMap) return false;

    const highlightChanged =
      JSON.stringify(propsFilters) !== JSON.stringify(filters) &&
      propsFilters?.data?.length > 0;

    const defaultChanged = default_filter !== propsDefault;

    const mapFiltersChanged =
      JSON.stringify(map_filters) !== JSON.stringify(last_saved_map_filters);

    return highlightChanged || defaultChanged || mapFiltersChanged;
  }



  saveFilter(apply) {
    const { filter_name, filter_id, default_filter } = this.state;
    const { filters, map_filters } = this.props;

    const merged_filters = {
      highlight_filters: filters,
      map_filters: {
        property_flags: map_filters.property_flags,
        property_types: map_filters.property_types,
        property_flags_and_or: map_filters.property_flags_and_or,
        beds_min: map_filters.beds_min,
        baths_min: map_filters.baths_min,
        use_beds_exact: map_filters.use_beds_exact,
        value_range_min: map_filters.value_range_min,
        value_range_max: map_filters.value_range_max,
        price_type: map_filters.price_type
      }
    };

    console.log("Saving filter with:", {
      title: filter_name,
      filters: merged_filters
    });
    this.props.updateSavedFilters({
      token: this.props.token,
      filter_type: "highlights",
      filters: this.props.applied_highlight,
      property_flags: this.props.map_filters?.property_flags
        .map(({ value }) => value)
        .join(","),
      property_types: this.props.map_filters?.property_types
        .map(({ value }) => value)
        .join(","),
      property_flags_and_or:
        this.props.map_filters?.property_flags_and_or,
      value_range_min: !!this.props.map_filters
        ?.value_range_min
        ? this.props.map_filters?.value_range_min
        : null,
      value_range_max: !!this.props.map_filters
        ?.value_range_max
        ? this.props.map_filters?.value_range_max
        : null,
      price_type: this.props.map_filters?.price_type,
      beds_min: this.props.map_filters?.beds_min,
      baths_min: this.props.map_filters?.baths_min,
      use_beds_exact: this.props.map_filters?.use_beds_exact,
      type: "create_saved_filter_with_title",
      default_filter: 0,
      advanced_filter_id: null,
      onLoading: () => {
        this.setState({ loading: true });
      },
      onError: () => {
        this.setState({ loading: false });
      },
      onSuccess: (results) => {
        this.setState({ loading: false });
        if (results?.saved_filters?.length) {
          const saved = results.saved_filters[0];
          const savedFilters = saved.filters || {};
          const newHighlightFilters = savedFilters.highlight_filters ?? this.state.filters;
          const newMapFilters = savedFilters.map_filters;
          this.setState({
            filters: newHighlightFilters,
            filter_id: saved.id,
            filter_name: saved.title,
            default_filter: saved.default_filter
          });

          this.props.updateFilters({
            filters: newHighlightFilters,
            filter_id: saved.id,
            filter_name: saved.title,
            default_filter: saved.default_filter
          });
          if (this.props.updateMapFilters && newMapFilters) {
            this.props.updateMapFilters(newMapFilters);
          }
        }

        if (apply) {
          this.props.setAppliedHighlight({ applied_highlight: this.state.filters });
          this.props.popSidePanel();
        }
      }

    });
  }


  render() {
    const { colors, isMobile, filters } = this.props;
    const { loading, filter_name } = this.state;

    let num = 0;
    for (let i = 0; i < this.props.filters?.data?.length; i++) {
      for (let j = 0; j < this.props.filters?.data[i]?.data?.length; j++) {
        num++;
      }
    }

    const can_edit = true;

    return (
      <>
        {can_edit &&
          !this.state.is_selecting &&
          this.checkIfNeedsToSave() && (
            <ConfirmLabel
              style={{ alignSelf: "stretch" }}
              primary={true}
              icon="tune"
              label={"Filters changed"}
              loading={this.state.loading}
              secondaryButton={
                this.state.filter_id === null
                  ? "Save Filter"
                  : this.state.confirm_save
                    ? "Just Save"
                    : ""
              }
              onSecondaryPress={() => {
                this.saveFilter(true);
              }}
              confirmButton={
                this.state.filter_id === null
                  ? "Apply"
                  : this.state.confirm_save
                    ? "Save and Apply"
                    : "Save"
              }
              onPress={() => {
                if (this.state.filter_id === null) {
                  this.props.setAppliedHighlight({
                    applied_highlight: this.props.filters
                  });
                  this.props.setLastSavedMapFilters(this.props.map_filters);
                  this.props.popSidePanel();
                } else if (this.state.confirm_save) {
                  this.saveFilter(true);
                } else {
                  this.setState({ confirm_save: true });
                }
              }}
            />
          )}




        <AdvancedFilters
          filters={filters}
          use_list_builder_info={true}
          editable={can_edit}
          open_filter={this.props.open_filter}
          renderHeader={
            !this.state.is_selecting && can_edit
              ? () => {
                return (
                  <Row>
                    <Wrapper style={{ flex: 1 }}>
                      <SmallHeader
                        title={
                          filters.data.length == 0 && !this.props.has_map_filters
                            ? "Select a filter:"
                            : "More filters:"
                        }
                      />
                    </Wrapper>
                    <InlineButton
                      onPress={() => {
                        this.props.pushSidePanel({
                          slug: "saved_searches",
                          overlay: true
                        });
                      }}
                    >
                      Saved Filters
                    </InlineButton>
                  </Row>
                );
              }
              : null
          }


          onSelecting={is_selecting => {
            this.setState({
              is_selecting: is_selecting
            });
          }}
          onChange={filters => {
            this.props.updateFilters({ filters });
          }}
        />
        {this.props.checkIfNeedsToApply() &&
          !this.state.is_selecting &&
          can_edit &&
          this.props.device === "mobile" ? (
          <BottomNavBar>
            <InlineButton
              button_type="full"
              primary={true}
              icon={num == 0 ? "close" : "tune"}
              style={{ backgroundColor: colors.orange_color_muted }}
              description={
                num == 0
                  ? ""
                  : num == 1
                    ? "1 Additional Filters"
                    : num + " Additional Filters"
              }
              onPress={() => {
                this.props.setAppliedHighlight({
                  applied_highlight: this.props.filters
                });
                this.props.popSidePanel();
              }}
            >
              {num == 0 ? "Clear More Filters" : "Apply More Filters"}
            </InlineButton>
          </BottomNavBar>
        ) : this.props.filter_id &&
          !this.checkIfNeedsToSave() &&
          !this.state.is_selecting &&
          can_edit ? (
          <BottomNavBar>
            <ConfirmInlineButton
              button_type="full"
              confirm_text="Really Delete?"
              loading_text="Deleting"
              confirm_icon="delete"
              loading={this.state.deleting}
              onPress={() => {
                this.props.updateSavedFilters({
                  token: this.props.token,
                  type: "remove_saved_filter",
                  advanced_filter_id: this.props.filter_id,
                  filter_type: "highlights",
                  onLoading: () => {
                    this.setState({
                      deleting: true
                    });
                  },
                  onError: () => {
                    this.setState({
                      deleting: false
                    });
                  },
                  onSuccess: results => {
                    this.setState({
                      deleting: false
                    });

                    this.props.popSidePanel();
                  }
                });
              }}
            >
              Delete Saved Highlights
            </ConfirmInlineButton>
          </BottomNavBar>
        ) : this.props.applied_highlight?.data?.length > 0 &&
          !this.props.checkIfNeedsToApply() &&
          can_edit ? (
          <BottomNavBar>
            <ConfirmInlineButton
              button_type="full"
              confirm_text="Really Clear?"
              loading_text="Clearing"
              loading={false}
              onPress={() => {
                this.props.setAppliedHighlight({
                  applied_highlight: {
                    data: [],
                    andor_type: "or"
                  }
                });

                this.props.popSidePanel();

                if (this.props.closeHighlightPopover) {
                  this.props.closeHighlightPopover();
                }
              }}
            >
              {"Clear All Additonal Filters"}
            </ConfirmInlineButton>
          </BottomNavBar>
        ) : null}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    map_filters: state.property_map.map_filters,
    last_saved_map_filters: state.property_map.last_saved_map_filters
  };
};

export default connect(
  mapStateToProps,
  {
    pushSidePanel,
    updateMapFilters,
    setLastSavedMapFilters
  }
)(HighlightFilters);


